'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';
import { API_CONFIG } from '@/config/api';
import { createAuthenticatedRequest } from '@/services/apiUtils';

interface PointsContextType {
  balance: number;
  updateBalance: () => Promise<void>;
}

const PointsContext = createContext<PointsContextType | undefined>(undefined);

export function PointsProvider({ children }: { children: React.ReactNode }) {
  const [balance, setBalance] = useState(0);

  const updateBalance = useCallback(async () => {
    try {
      const data = await createAuthenticatedRequest<{ balance: number }>(
        `${API_CONFIG.baseUrl}${API_CONFIG.endpoints.points.balance}`
      );
      setBalance(data.balance);
    } catch (error) {
      console.error('Error fetching points balance:', error);
      // Don't throw the error to prevent crashes, just log it
    }
  }, []);

  return (
    <PointsContext.Provider value={{ balance, updateBalance }}>
      {children}
    </PointsContext.Provider>
  );
}

export function usePoints() {
  const context = useContext(PointsContext);
  if (context === undefined) {
    throw new Error('usePoints must be used within a PointsProvider');
  }
  return context;
}